<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" [resizable]="false"
  appendTo="body">

  <p-header>
    <span>License Update Wizard</span>
  </p-header>

  <div class="wizard-container">
    @if (page === WelcomePage) {
      <div>
        <p style="margin-top: 30px;">
          This wizard will step you through the process of updating your UVexplorer Server license.
        </p>
        <p style="margin-top: 20px;">
          NOTE: An Internet connection is required to perform this operation.
        </p>
        <p style="margin-top: 20px;">
          To continue, click Next.
        </p>
      </div>
    }
    @if (page === CompletionPage) {
      <div>
        <p style="margin-top: 30px;">
          Congratulations!  You have successfully updated your license.
        </p>
        <p style="margin-top: 20px;">
          To close this wizard, click Finish.
        </p>
      </div>
    }
    @if (page === OnlinePage) {
      <div>
        <p style="margin-top: 30px;">
          When you click the Update button below, we will contact the UVnetworks licensing server
          and download any changes that have been made to the details of your license (if any).
          This will ensure that you are running with a current and up-to-date license.
        </p>
        <p style="margin-top: 20px;">
          Updating your license is most useful when you purchase additional product features on
          the UVnetworks web site.  By updating your license, the new features will become available
          on this computer.
        </p>
      </div>
    }
    @if (page === OnlineFailedPage) {
      <div>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 30px;">
          {{onlineFailedLabel}}
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          If you would like to try again, click the Back button.
        </p>
      </div>
    }
    @if (page === InternetFailedPage) {
      <div>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 30px;">
          It appears that this computer is currently not connected to the Internet.
          Therefore, license update is not possible at this time.
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          You can try again later when this computer is connected to the Internet.
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          To retry license update, click the Back button.
        </p>
      </div>
    }
  </div>

  <p-footer>
    <button type="button" pButton [disabled]="!enableBack" (click)="onBackClicked()" label="{{backLabel}}"></button>
    <button type="button" pButton [disabled]="!enableNext" (click)="onNextClicked()" label="{{nextLabel}}"></button>
    <button type="button" pButton [disabled]="!enableCancel" (click)="onCancelClicked()" label="{{cancelLabel}}"></button>
  </p-footer>

</p-dialog>
